export const loadState = (localStorageName) => {
    try {
        const serializedState = localStorage.getItem(localStorageName)
        if (serializedState === null) {
            return undefined
        }
        return JSON.parse(serializedState)
    } catch (err) {
        return undefined
    }
}

export const saveState = (localStorageName, state) => {
    try {
        let stateToSave = {token: state.token, cart: state.cart, clientDataStep: state.clientDataStep, outsourcing: state.outsourcing/*, software:state.software*/}
        if (state.crossSelling && state.crossSelling.selectedArticle) {
            stateToSave.crossSelling.selectedArticle = state.crossSelling.selectedArticle
        }
        const serializedState = JSON.stringify(stateToSave);
        localStorage.setItem(localStorageName, serializedState)
    } catch (err) {
    }
}

export const clearState = (persistedState) => {

    try {
        localStorage.removeItem(persistedState)
    } catch (err) {
    }

}


/** WEBPACK FOOTER **
 ** ./src/localStorage/localStorage.js
 **/